/* Copyright (c) 2026 Xperi. All Rights Reserved. */

import { Log } from "../logging";
import { ScopedDomainTokenModel } from "../videoplayer/impls/drm/ScopedDomainTokenModel";
import { SDTInfo } from "../videoplayer/interfaces";

export class TokenRefreshMechanism {
  private static oTokenRefreshMechanism: TokenRefreshMechanism;

  private mSDTModel;

  private static tokenRefreshTimeOut: ReturnType<typeof setTimeout>;

  private readonly TAG = "TokenRefreshMechanism";

  private constructor() {
    this.mSDTModel = ScopedDomainTokenModel.getInstance();
  }

  private log(level: "debug" | "info" | "error", message: string): void {
    if (level === "debug") {
      Log.d(this.TAG, message);
    } else if (level === "info") {
      Log.i(this.TAG, message);
    } else if (level === "error") {
      Log.e(this.TAG, message);
    } else {
      Log.w(this.TAG, message);
    }
  }

  static getInstance(): TokenRefreshMechanism {
    if (!TokenRefreshMechanism.oTokenRefreshMechanism)
      TokenRefreshMechanism.oTokenRefreshMechanism =
        new TokenRefreshMechanism();
    return TokenRefreshMechanism.oTokenRefreshMechanism;
  }

  public scheduleDomainTokenRefresh(sdtInfo: SDTInfo): void {
    clearTimeout(TokenRefreshMechanism.tokenRefreshTimeOut);
    // TODO: Add Diagnostics logging for scope domain token with earliest expiration time

    TokenRefreshMechanism.tokenRefreshTimeOut = setTimeout(async () => {
      try {
        // Forced: the stored token is still valid at this point — that is
        // the point of refreshing early — so an unforced call would just
        // hand it back and the next refresh would land closer to expiry.
        await this.mSDTModel.getToken(
          sdtInfo.drmCustomDomain,
          sdtInfo.drmCustomHeaderAuthScheme,
          true,
          true
        );
      } catch (error) {
        this.log("error", `Failed to schedule Domain Token refresh: ${error}`);
      }
    }, sdtInfo.refreshTime);
  }
}
